window.cafe = cafe || {};
cafe.apply = cafe.apply || {};

(function () {
	var SERVICE_MESSAGE = {
		100: "참여 권한이 없습니다.",
		101: "회원님은 이미 작성하셨습니다. \n이 게시판은 중복 참여할 수 없습니다.",
		102: "참여 기간이 아닙니다.",
		103: "삭제된 글입니다.",
		104: "참여게시판이 존재하지 않습니다.",
		105: "해당 게시판이 존재하지 않거나\n접근 권한이 없습니다.",
		APPLY_END: "참여 기간이 종료되었습니다."
	};
	var ERROR_STATUS_MESSAGE = {
		401: "참여 권한이 없습니다.",
		404: "존재하지 않습니다.",
		409: "참여글을 작성/수정 할 수 없습니다.",
		500: "오류가 발생하였습니다. 잠시 후 다시 시도해주세요."
	};

	function getMessage(xhr) {
		if (xhr.responseJSON) {
			message = SERVICE_MESSAGE[xhr.responseJSON.code];
		}
		if (message !== undefined) {
			return message;
		}

		var message = ERROR_STATUS_MESSAGE[xhr.status];
		if (message !== undefined) {
			return message;
		}

		return "오류가 발생하였습니다. 잠시 후 다시 시도해주세요";
	}

	cafe.EXCEPTION = (function () {
		return {
			getMessage: getMessage,
			SERVICE_MESSAGE: SERVICE_MESSAGE
		}
	})();
})();
